export default __webpack_public_path__ + "static/media/img_22.4701494d.jpg";